import { createContext, useContext, useMemo, ReactNode } from 'react'
import { usePreferences } from '../preferences/PreferencesContext'

interface KidModeContextValue {
  isKidMode: boolean
  enable(): void
  disable(): void
}

const KidModeContext = createContext<KidModeContextValue>({
  isKidMode: false,
  enable: () => {},
  disable: () => {},
})

export function useKidMode() {
  return useContext(KidModeContext)
}

export function KidModeProvider({ children }: { children: ReactNode }) {
  const { prefs, setPref } = usePreferences()

  const value = useMemo<KidModeContextValue>(
    () => ({
      isKidMode: !!prefs.kidMode,
      enable: () => setPref('kidMode', true),
      disable: () => setPref('kidMode', false),
    }),
    [prefs.kidMode, setPref],
  )

  return <KidModeContext.Provider value={value}>{children}</KidModeContext.Provider>
}
